import WMSMapLayer from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer';
import { ZoningIcon, DevelopmentIcon, SalesIcon, TerrainIcon, SchoolIcon } from '@domain-group/fe-co-icon';
export var SCHOOL_LAYER_DEFAULT = WMSMapLayer.FUTURE_PRIMARY_SCHOOL.id;
export var SCHOOL_LAYER_HIGH_SCHOOL = WMSMapLayer.FUTURE_HIGH_SCHOOL.id;
export var SCHOOL_LAYER_COLLEGE = WMSMapLayer.FUTURE_COLLEGE.id;
export default [{
  title: 'Territory planning zones',
  icon: ZoningIcon,
  description: "A block's planning zone defines how that land can be used and what can be built on it.",
  key: WMSMapLayer.TP_ZONES.id
}, {
  title: 'Easement information',
  icon: DevelopmentIcon,
  description: 'A right to use a part of land owned by another person for a specific purpose. The most common forms of easements are for services, such as water, electricity or sewerage.',
  key: WMSMapLayer.EASEMENTS.id
}, {
  title: 'Unimproved land values',
  icon: SalesIcon,
  description: "The value of a block of land without any buildings, landscaping, paths, or fences. This is different to the block's market value. A block's unimproved value is used to calculate rates and land tax charges.",
  key: WMSMapLayer.UNIMPROVED_LAND_VALUES.id
}, {
  title: 'Land contours',
  icon: TerrainIcon,
  description: 'This represents the shape of the geographical land. Closely spaced contour lines represent a steep slope. Widely spaced lines represent a gentle slope.',
  key: WMSMapLayer.CONTOURS.id
}, {
  title: 'ACT public school priority enrolment areas',
  icon: SchoolIcon,
  description: 'Enrolment areas for ACT public schools.',
  key: SCHOOL_LAYER_DEFAULT
}];